// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".birthday-packages[data-v-8ed25758]{margin-bottom:25px}@media(min-width:600px){.birthday-packages[data-v-8ed25758]{margin-bottom:50px}}.holiday-events .event-subcategories[data-v-8ed25758]{padding:20px 0}.holiday-events .event-subcategories>div[data-v-8ed25758]:last-of-type,.holiday-events .event-subcategories h2[data-v-8ed25758]{display:none}", ""]);
// Exports
module.exports = exports;
